import Avatar from 'antd/lib/avatar/avatar';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import useDimensions from '@tools/ui-hooks/useDimensions.hook';
import { userStore } from '@tools/ui-stores';
import { SideMenuPopover } from '../SideMenuPopover';
import PopoverUserProfile from './PopoverUserProfile.component';

const AvatarStyle = styled(Avatar)`
  margin-top: -100px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const UserProfile: React.FC<React.PropsWithChildren> = observer(() => {
  const { height: windowHeight } = useDimensions();
  const user = userStore.getCurrentUser();

  return (
    <SideMenuPopover
      width={280}
      top={windowHeight - 360}
      left={90}
      content={<PopoverUserProfile />}
    >
      <AvatarStyle size={40} src={user?.picture} />
    </SideMenuPopover>
  );
});

export default UserProfile;
